import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { setSession as setGlobalSession, setMdMode as setGlobalMdMode, getConnState } from "../../shared/config/conn";

const QueryCtx = createContext(null);

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (String(error?.message || "").toLowerCase().includes("pacing")) return false;
        return failureCount < 2;
      },
    },
  },
});

export default function QueryProvider({ children }) {
  const [session, setSession] = useState(getConnState().session);
  const [mdMode, setMdMode] = useState(getConnState().mdMode);

  // Keep global params in sync so ALL requests pick them up automatically
  useEffect(() => { setGlobalSession(session); }, [session]);
  useEffect(() => { setGlobalMdMode(mdMode); }, [mdMode]);

  const value = useMemo(
    () => ({ session, setSession, mdMode, setMdMode }),
    [session, mdMode]
  );

  return (
    <QueryCtx.Provider value={value}>
      <QueryClientProvider client={client}>{children}</QueryClientProvider>
    </QueryCtx.Provider>
  );
}

export function useQueryCtx() {
  const ctx = useContext(QueryCtx);
  if (!ctx) throw new Error("useQueryCtx must be used within <QueryProvider>");
  return ctx;
}